var _circle, _circle2, _circle3, _path, _path2, _circle4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOther(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.52 42.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_filled",
    cx: 15.569,
    cy: 24.856,
    r: 0.73
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_filled",
    cx: 21.26,
    cy: 24.856,
    r: 0.73
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_filled",
    cx: 26.951,
    cy: 24.856,
    r: 0.73
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M24.436 10.772h11.91a3.24 3.24 0 013.24 3.24V35.7a3.24 3.24 0 01-3.24 3.24H6.174a3.24 3.24 0 01-3.24-3.24V14.012a3.24 3.24 0 013.24-3.24H17.27"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M24.11 7.189l2.894-2.852c1.842-2.212 5.359-1.757 6.578.85 1.219 2.608-.687 5.598-3.565 5.593l-5.581-.009M17.328 7.25l-2.662-2.921c-1.842-2.212-5.359-1.757-6.578.85-1.219 2.608.687 5.598 3.565 5.593l5.581-.009"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 20.862,
    cy: 10.772,
    r: 1.445
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOther);
export default __webpack_public_path__ + "static/media/other.7737afe84b446f7d69a79a1388db9167.svg";
export { ForwardRef as ReactComponent };